import * as React from 'react';
import { JSX } from 'react/jsx-runtime';
const EditIconDark = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_98_38067)">
      <path
        d="M5.83398 5.83203H5.00065C4.55862 5.83203 4.1347 6.00763 3.82214 6.32019C3.50958 6.63275 3.33398 7.05667 3.33398 7.4987V14.9987C3.33398 15.4407 3.50958 15.8646 3.82214 16.1772C4.1347 16.4898 4.55862 16.6654 5.00065 16.6654H12.5007C12.9427 16.6654 13.3666 16.4898 13.6792 16.1772C13.9917 15.8646 14.1673 15.4407 14.1673 14.9987V14.1654"
        stroke="#EEF7FF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.9875 5.48759C17.3157 5.15938 17.5001 4.71424 17.5001 4.25009C17.5001 3.78594 17.3157 3.34079 16.9875 3.01259C16.6593 2.68438 16.2142 2.5 15.75 2.5C15.2858 2.5 14.8407 2.68438 14.5125 3.01259L7.5 10.0001V12.5001H10L16.9875 5.48759V5.48759Z"
        stroke="#EEF7FF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.334 4.16797L15.834 6.66797"
        stroke="#EEF7FF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_98_38067">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default EditIconDark;
